import { SvgTickerLogo } from '../svg/img-ticker-logo';
import { SvgTickerText } from '../svg/img-ticker-text';

/**
 * ティッカースクロールコンポーネントのprops
 * @param width - 1アイテムあたりの幅（px）
 * @param repeat - アイテムの繰り返し回数（デフォルト: 6）
 */
type TickerProps = {
  width: number;
  repeat?: number;
};

export const SiteTickerScroll = ({ width, repeat = 6 }: TickerProps) => {
  const Item = () => (
    <div className="mr-2 flex" style={{ width }}>
      <SvgTickerLogo className="mr-2 h-[20px] w-[101px]" aria-label="カブ活ロゴ" />
      <SvgTickerText className="mt-1 h-[16px] w-[99px]" aria-label="賢く株を貯めるなら" />
    </div>
  );
  const items = Array.from({ length: repeat }, (_, i) => <Item key={i} />);
  const trackStyle = {
    width: `${width * repeat}px`,
    animation: `var(--animate-ticker-scroll)`,
  } as React.CSSProperties;
  return (
    <div className="relative h-[20px] w-full max-w-full overflow-x-hidden">
      <div className="absolute top-0 left-0 flex items-end" style={trackStyle}>
        {items}
      </div>
    </div>
  );
};
